// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"46fa6372","488":"22478461"}[chunkId] + ".chunk.js";
};